module.exports = __webpack_public_path__ + "img/0.bdd6da74.png";